import type { AppNode } from '@/nodes';
import { shallowEqual } from '@rock/util';
import { useAtom } from 'jotai/index';
import { atomFamily, atomWithStorage, createJSONStorage } from 'jotai/utils';
import type { DeepPartial, FieldValues } from 'react-hook-form';

export const nodeFormState = atomFamily(
    ({ flowId, nodeId }: { flowId: string; nodeId: string }) =>
        atomWithStorage<AppNode['data'] | null>(
            `form:${flowId}:${nodeId}`,
            null,
            createJSONStorage(() => sessionStorage),
        ),
    shallowEqual,
);

export function useSavedFormValues<T extends FieldValues>({ flowId, nodeId }: { flowId: string; nodeId: string }) {
    return useAtom(nodeFormState({ flowId, nodeId })) as [DeepPartial<T> | null, (d: DeepPartial<T> | null) => void];
}
